import { Tag } from "../../Tag";

export class TextItemEntry extends Tag {
    public getValue() {
        try {
            const vTag = this.findByAttribute("v");
            const v = JSON.parse(vTag.getAttribute("v"));
            return v.v;
        } catch (e) {
            return this.getAttribute("v");
        }
    }

    public equals(value: any) {
        return this.getValue() === value;
    }
}
